import { GraphThumbnail } from '../../../types';
import { State } from './State';

export const initialState = (initialGraphs: GraphThumbnail[]): State => {
  return {
    graphs: initialGraphs,
  };
};
